export const DNDTypes = {
	BACKGROUND: "background",
	WINDOW: "window"
}



// WEBPACK FOOTER //
// ./src/components/windowed/DNDTypes.js